export default "__VITE_ASSET__xWn85oY7__"